<template>
    <div class="add-log center-box">
        <InnerHeader>申请修改资料</InnerHeader>

        <!--申请列表-->
        <div class="add-teacher">
            <!--老师姓名-->
            <div class="form-item" v-if="info.name">
                <label>老师姓名</label>
                <div class="input-box">
                    {{info.name}}
                </div>
            </div>

            <!--获评年份-->
            <div class="form-item" v-if="info.name">
                <label>获评年份</label>
                <div class="input-box">
                    {{info.year}}年
                </div>
            </div>

            <!--政治面貌-->
            <div class="form-item">
                <label>政治面貌</label>
                <div class="input-box">
                    <el-input required v-model="info.outlook" placeholder="政治面貌"></el-input>
                </div>
            </div>

            <!--老师学历-->
            <div class="form-item">
                <label>学&emsp;&emsp;历</label>
                <div class="input-box">
                    <el-select filterable v-model.trim="info.education" placeholder="学历">
                        <el-option
                            v-for="item in eduList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <!--联系方式-->
            <div class="form-item">
                <label>联系方式</label>
                <div class="input-box">
                    <el-input required v-model="info.mobile" placeholder="联系方式"></el-input>
                </div>
            </div>

            <!--从教年限-->
            <div class="form-item">
                <label>从教年限</label>
                <div class="input-box">
                    <el-input required v-model="info.worklife" placeholder="从教年限"></el-input>
                </div>
            </div>

            <!--现任职务-->
            <div class="form-item">
                <label>现任职务</label>
                <div class="input-box">
                    <el-input required v-model="info.nowduty" placeholder="现任职务"></el-input>
                </div>
            </div>

            <!--专业职务-->
            <div class="form-item">
                <label>专业职务</label>
                <div class="input-box">
                    <el-input required v-model="info.specialduty" placeholder="专业职务"></el-input>
                </div>
            </div>
           
            <!--资料图片-->
            <div class="form-item no-flex">
                <div>证明材料</div>
                <div class="upload-area">
                    <UploadImg
                        :index="1"
                        :multiple="true"
                        :limit="10"
                        :imgurl="images"
                        :headers="headers"
                        @success="success"
                        @remove="remove" />
                </div>
            </div>
           
            <!--保存-->
            <div class="btns">
                <el-button @click="save" size="medium" type="primary">确定</el-button>
            </div>
        </div>
        <RequestLoading :show="show" />
    </div>
</template>

<script>
import InnerHeader from '@/components/layout/InnerHeader';
import RequestLoading from '@/components/tool/RequestLoading';
import {mapGetters} from "vuex";
import {EDUCATIONS} from '@/configs/configs';
import UploadImg from '@/components/tool/UploadImg';
import {getInitAppInfo, addLog} from '@/services/applogs';
import {strValidate,phoneCheck,numConvert, checkImagesNum} from '@/assets/js/tool';

export default {
    name: 'AddLog',
    components: {
        InnerHeader,
        RequestLoading,
        UploadImg
    },
    computed: {
        headers() {
            return {
                token: this.userInfo.token,
                userid: this.userInfo.userid
            };
        },
        //接受id
        aid() {
            let aid = this.$route.params.aid;
            aid = (parseInt(aid) > 0) ? parseInt(aid) : 0;
            return aid;
        },
        id() {
            let id = this.$route.params.id;
            id = (parseInt(id) > 0) ? parseInt(id) : 0;
            return id;
        },
        ...mapGetters(['userInfo'])
    },
    data() {
        return {
            eduList: EDUCATIONS,
            //资料图片
            images: '',
            imgList: [],
            //记录信息
            info: {},
            show: false
        };
    },
    created() {
        //获取资料
        this.getInitAppInfo();
    },
    methods: {
        //获取需要修改资料的初始信息
        async getInitAppInfo() {
            try {
                if(this.aid > 0) {
                    this.show = true;
                    let res = await getInitAppInfo({
                        aid: this.aid,
                        id: this.id
                    });
                    this.show = false;
                    this.info = res;
                    //初始化图片
                    this.initImages(this.info.images, 1);
                };
            } catch(err) {
                this.msg(err, 3);
                this.show = false;
            }
        },

        //初始化图片
        initImages(imgStr, index) {
            let arr = null
            if(imgStr && (arr = imgStr.split(';')) && arr.length) {
                switch(index) {
                    case 1:
                        this.images = this.info.images || '';
                        this.imgList = arr;
                        break;
                }
            }
        },

        //成功上传老师的照片
        success(obj) {
            if(obj && obj.url) {
                if(obj.index === 1) {
                    //去添加图片
                    this.imgList.push(obj.url);
                    this.info.images = this.imgList.join(';');
                }
            }
        },

        //移除老师的照片
        remove(obj) {
            if(obj && obj.url) {
                if(obj.index === 1) {
                    let index = this.imgList.findIndex((item) => {
                        return item === obj.url
                    });
                    if(index >= 0) {
                        this.imgList.splice(index, 1);
                        this.info.images = this.imgList.join(';');
                    }
                }
            }
        },

        //保存
        save() {
            //发送数据
            let data = {
                id: this.id,
                aid: this.aid
            };

            //政治面貌
            let outlook = strValidate(this.info.outlook, '政治面貌', false, 1, 30);
            if(!outlook) {
                this.msg('请填写老师的政治面貌', 2);
                return;
            }
            data.outlook = outlook;

            //学历
            let education = numConvert(this.info.education);
            if(education <= 0) {
                this.msg('请选择学历', 2);
                return;
            }
            data.education = education;

            //联系方式
            if(!phoneCheck(this.info.mobile)) {
                this.msg('请填写正确的联系方式', 2);
                return;
            }
            data.mobile = this.info.mobile || '';

            //从教年限
            let worklife = numConvert(this.info.worklife);
            if(worklife <= 0) {
                data.worklife = 0;
            } else {
                data.worklife = worklife || 0;
            }

            //现任职务
            let nowduty = strValidate(this.info.nowduty, '现任职务', true, 2, 50);
            if(nowduty === false) {
                return;
            }
            data.nowduty = nowduty || '';

            //专业职务
            let specialduty = strValidate(this.info.specialduty, '专业职务', false, 2, 50);
            if(!specialduty) {
                return;
            }
            data.specialduty = specialduty || '';

            //资料图片
            if(!checkImagesNum(this.info.images)) {
                this.msg('资料图片不超过10张', 2);
                return;
            }
            data.images = this.info.images || '';

            //发送数据到服务器
            this.sendData(data);
        },

         //发送数据到服务器
         async sendData(data) {
            try {
                this.show = true;
                await addLog(data);
                this.show = false;
                //操作成功
                this.msg('操作成功', 4);
                setTimeout(() => {
                    this.$router.push({
                        name: 'appLogs'
                    });
                }, 500);
            } catch(err) {
                this.show = false;
                this.msg(err, 3);
            }
        }
    }
}

</script>

<style scoped>
.add-log {
    width: 100%;
    padding: 0 0.8rem;
    padding-bottom: 1rem;
}
.form-wrapper {
    margin-top: 4rem;
}
.no-flex {
    display: block;
}
.no-flex .upload-area {
    margin-top: 1rem;
}
.no-flex .input-box {
    margin-top: 1rem;
    margin-left: 0;
    max-width: 90%;
}
.btns {
    width: 100%;
    text-align: center;
}
.btns button {
    width: 80%;
    max-width: 200px;
    height: 46px;
    background-color: #cc0033;
    border: none;
}
.btns button:last-child {
    margin: 0;
}
.links-title button,/deep/ .el-radio__input.is-checked .el-radio__inner{
    background-color: #cc0033;
    border: 1px solid #cc0033;
}
/deep/ .el-radio__input.is-checked+.el-radio__label {
    color: #cc0033;
}
</style>